import { getSupabaseClient } from './supabase';

export async function invokeV4<T>(functionName:string,action:string,payload:Record<string,unknown>):Promise<T>{
  const{data,error}=await getSupabaseClient().functions.invoke(functionName,{body:{action,payload},headers:{'x-request-id':crypto.randomUUID()}});
  if(error)throw new Error(await edgeMessage(error));
  if(data?.error)throw new Error(data.error.message??'远程操作失败。');
  return data?.data as T;
}

export async function tableRows<T>(table:string,select='*'):Promise<T[]>{
  const{data,error}=await getSupabaseClient().from(table).select(select);
  if(error)throw new Error(error.message);
  return(data??[])as T[];
}

async function edgeMessage(error:unknown){
  const context=(error as{context?:Response})?.context;
  if(context){try{const body=await context.clone().json();return body?.error?.message??body?.message??String(error);}catch{/* fall through */}}
  return error instanceof Error?error.message:'远程操作失败。';
}
